class DetailsInactiveOnDesktopManager {
    constructor() {
        this._init()
    }
    _init() {
        this.isMobile = this.checkIsMobile()
        this.els = document.querySelectorAll('[data-mobile-details]')
        this.els.forEach(el => el.detail = new Detail(el))
        window.addEventListener('resize', () => this.onResize())
    }
    onResize() {
        const newMobile = this.checkIsMobile()
        if(newMobile !== this.isMobile) {
            this.isMobile = newMobile
            this.els.forEach(el => el.detail.onMediaChange())
        }
    }
	checkIsMobile() {
		return !window.matchMedia("only screen and (min-width: 1024px)").matches
	}
}
class Detail {
    constructor(el) {
        this._init(el)
    }
    _init(el) {
        this.el = el
        this.open = false
        if(this.isMobile()) {
            this.el.open = false
        }
        if(!this.el) {
            return
        }
        this.elAction = this.el.querySelector('[data-mobile-details-action]')
        this.elAction.addEventListener('click', (e) => this.onActionClick(e))
        this.onMediaChange()
    }    
    onMediaChange() {
        if(!this.isMobile()) {
            this.el.open = true
        } else {
            this.el.open = this.open
        }
    }
    onActionClick(e) {
        if(!this.isMobile()) {
            e.preventDefault()
            return false
        } else {
            this.open = !this.open
        }
    }
	isMobile() {
		return !window.matchMedia("only screen and (min-width: 1024px)").matches
	}
}

export default DetailsInactiveOnDesktopManager